<cerrix-loader [cerrixTab]="tab"></cerrix-loader>

@if (!tab.showLoader && user) {
    <div menuSystem [cerrixTab]="tab" class="screen-system" (changeEvent)="handleMenuItemClick($event)">
        <div
            class="user-screens"
            [attr.name]="'userProfile.userManagementMenuLabel' | transloco"
            menuItemId="menuItemUserManagement"
            menuicon="fas fa-user-cog"
            menusystemsubmenu
        >
            <div
                [attr.name]="'userProfile.profileMenuLabel' | transloco"
                menuItemId="menuItemProfile"
                menuicon="fas fa-user"
                menusystemitem
            >
                <div class="row">
                    <div class="col">
                        <div class="detail-page-card">
                            <div
                                class="detail-page-card-title"
                                data-uiid="user-profile-basic-information-title"
                            >
                                {{ "userProfile.basicInformationTitle" | transloco }}
                            </div>
                            <div class="detail-page-card-actions">
                                <button
                                    class="btn btn-raised red"
                                    data-uiid="user-profile-logout-button"
                                    (click)="logout()"
                                >
                                    <i class="fas fa-sign-out-alt"></i>
                                    <span class="ms-2">{{
                                        "userProfile.logoutButton" | transloco
                                    }}</span>
                                </button>
                            </div>
                            <div
                                class="detail-page-card-body padded cerrix-control-sm form-group-styling"
                            >
                                <div class="form-group">
                                    <label>{{ "userProfile.firstnameLabel" | transloco }}</label>
                                    <input
                                        type="text"
                                        class="form-control form-control-sm"
                                        [(ngModel)]="user.firstname"
                                        disabled
                                    />
                                </div>
                                <div class="form-group">
                                    <label>{{ "userProfile.lastnameLabel" | transloco }}</label>
                                    <input
                                        type="text"
                                        class="form-control form-control-sm"
                                        [(ngModel)]="user.lastname"
                                        disabled
                                    />
                                </div>
                                <div class="form-group">
                                    <label>{{ "userProfile.emailLabel" | transloco }}</label>
                                    <input
                                        type="email"
                                        class="form-control form-control-sm"
                                        [(ngModel)]="user.email"
                                        disabled
                                    />
                                </div>
                                <div class="form-group">
                                    <label>{{
                                        "userProfile.organizationLabel" | transloco
                                    }}</label>
                                    <input
                                        type="text"
                                        class="form-control form-control-sm"
                                        [(ngModel)]="user.organization"
                                        disabled
                                    />
                                </div>
                                <div class="form-group">
                                    @let languageUpdatedMessage =
                                        "userProfile.languageUpdatedMessage" | transloco;
                                    <div class="form-label">
                                        {{ "userProfile.languageLabel" | transloco }}
                                    </div>
                                    <cerrix-select
                                        dataUiid="user-profile-language"
                                        [getDataMethod]="languageOptions$"
                                        [value]="languageSelectValue"
                                        (valueChange)="
                                            languageChanged($event, languageUpdatedMessage)
                                        "
                                        [clearable]="false"
                                        bindLabel="Name"
                                        bindValue="ID"
                                    ></cerrix-select>
                                </div>
                            </div>
                        </div>
                    </div>

                    @if (user.passwordChangeAllowed) {
                        @let passwordUpdatedMessage =
                            "userProfile.passwordUpdatedMessage" | transloco;
                        @let successTitle = "userProfile.successTitle" | transloco;
                        @let updateFailedTitle = "userProfile.updateFailedTitle" | transloco;
                        <div class="col-12 col-md-6">
                            <div class="detail-page-card">
                                <div class="detail-page-card-title">
                                    {{ "userProfile.changePasswordTitle" | transloco }}
                                </div>
                                <div class="detail-page-card-actions">
                                    <button
                                        class="btn btn-raised"
                                        (click)="
                                            changePassword(
                                                passwordUpdatedMessage,
                                                successTitle,
                                                updateFailedTitle
                                            )
                                        "
                                    >
                                        <i class="fas fa-unlock"></i>
                                        <span class="ms-2">{{
                                            "userProfile.updatePasswordButton" | transloco
                                        }}</span>
                                    </button>
                                </div>
                                <div
                                    class="detail-page-card-body padded cerrix-control-sm form-group-styling"
                                >
                                    <div class="form-group">
                                        <label>{{
                                            "userProfile.usernameLabel" | transloco
                                        }}</label>
                                        <input
                                            type="text"
                                            class="form-control form-control-sm"
                                            [(ngModel)]="user.username"
                                            disabled
                                        />
                                    </div>
                                    <div class="form-group">
                                        <label>{{
                                            "userProfile.oldPasswordLabel" | transloco
                                        }}</label>
                                        <input
                                            type="password"
                                            class="form-control form-control-sm"
                                            [(ngModel)]="passwordChangeModel.oldPassword"
                                        />
                                    </div>
                                    <div class="form-group">
                                        <label>{{
                                            "userProfile.newPasswordLabel" | transloco
                                        }}</label>
                                        <input
                                            type="password"
                                            class="form-control form-control-sm"
                                            [(ngModel)]="passwordChangeModel.newPassword"
                                        />
                                    </div>
                                    <div class="form-group">
                                        <label>{{
                                            "userProfile.confirmNewPasswordLabel" | transloco
                                        }}</label>
                                        <input
                                            type="password"
                                            class="form-control form-control-sm"
                                            [(ngModel)]="passwordChangeModel.newPasswordConfirm"
                                        />
                                    </div>
                                </div>
                            </div>
                        </div>
                    }
                </div>

                <user-audit [audit]="user.audit" [loadOnStartup]="true"></user-audit>
            </div>

            @if (user) {
                <div
                    [attr.name]="'userProfile.notificationSettingsMenuLabel' | transloco"
                    menuItemId="notification-settings"
                    menuicon="fas fa-bell"
                    menusystemitem
                >
                    <user-notification-settings
                        [userModel]="user"
                        [parentTab]="tab"
                    ></user-notification-settings>
                </div>
            }

            <div
                [attr.name]="'userProfile.rolesMenuLabel' | transloco"
                menuItemId="roles"
                menuicon="fas fa-user-tag"
                menusystemitem
            >
                <div class="detail-page-action-bar">
                    <span
                        class="date-edited"
                        [innerHTML]="'userProfile.rolesHelpText' | transloco"
                    ></span>
                </div>

                <role-assign
                    [moduleRoles]="user.moduleRoles"
                    [(userModel)]="user"
                    [allowChange]="false"
                >
                </role-assign>
            </div>
            <div
                [attr.name]="'userProfile.apiKeysMenuLabel' | transloco"
                menuItemId="api-keys"
                menuicon="fas fa-key"
                menusystemitem
            >
                <api-key-overview></api-key-overview>
            </div>
            @if (ipConfigType) {
                <div
                    [attr.name]="'userProfile.ipWhitelistingMenuLabel' | transloco"
                    menuItemId="ip-whitelisting"
                    menuicon="fal fa-location"
                    menusystemitem
                >
                    <standingdata-generic
                        [type]="ipConfigType"
                        [name]="'userProfile.ipConfigLabel' | transloco"
                    ></standingdata-generic>
                </div>
            }
        </div>
    </div>
}
